import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import { AccaPublicTestResultStoreType, useAccaPublicTestResultStore } from '@stores/AccaPublicTestResultStore';
import { AccaTestResultStoreType, useAccaTestResultStore } from '@stores/AccaTestResultStore';

interface ResultStoreContext {
  isPublicStore: boolean;
  accaResultStore: AccaPublicTestResultStoreType | AccaTestResultStoreType;
}

const ResultStoreContext = React.createContext<ResultStoreContext>({
  isPublicStore: false,
  accaResultStore: {} as AccaPublicTestResultStoreType | AccaTestResultStoreType,
});

interface Props {
  isPublicStore: boolean;
  children: React.ReactNode;
}

export const ResultStoreProvider = function ({ isPublicStore, children }: Props) {
  const accaPublicTestResultStore = useAccaPublicTestResultStore(useShallow((state) => state));
  const accaTestResultStore = useAccaTestResultStore(useShallow((state) => state));
  return (
    <ResultStoreContext.Provider
      value={{ isPublicStore, accaResultStore: isPublicStore ? accaPublicTestResultStore : accaTestResultStore }}
    >
      {children}
    </ResultStoreContext.Provider>
  );
};

export function useResultStore() {
  const context = React.useContext(ResultStoreContext);
  if (context === undefined) {
    throw new Error('useResultStore Hook은 ResultStoreProvider 내부에서 사용되어야 합니다.');
  }

  return context;
}
